// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f2663c2c","865":"b63115b1","911":"aac35cf0","920":"e0a1b9d4","977":"9e1cbb90"}[chunkId] + ".chunk.js";
};